export const AnaliseValues = {
    PATH_JOGOS_RPG: 'jogos-eletronicos-rpg',
    PATH_CINEMA_HOME_VIDEO: 'cinema-home-video',
    PATH_SEAC_VOD: 'seac-vod',
    PATH_TV_ABERTA: 'tv-aberta',
    PATH_RADIO: 'radio',
    PATH_ATRIBUIR_CLASSIFICACAO: 'atribuir-classificacao/:id',
};
